module.exports = __webpack_public_path__ + "img/AbdulqadirSaed-GorGharyb.92e1f163.jpg";